import {ApolloError} from '@apollo/client';

/**
 * Generic user-facing copy for errors we don't recognize. Raw GraphQL /
 * transport error messages must never render in the UI.
 */
export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';

/**
 * True when the error carries the backend's typed not-found error
 * (`extensions.type === 'not_found_error'`). The chat stream subscription
 * raises it when the stream session's server-side state has expired.
 */
export function isNotFoundGraphQLError(error: unknown): boolean {
  return (
    error instanceof ApolloError &&
    error.graphQLErrors.some((e) => e.extensions?.type === 'not_found_error')
  );
}
